import styled from 'styled-components';

export const FormContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 90%;
  min-height: 100vh;
  height: auto;
  margin: 0 auto;
  margin-top: ${({ theme }) => theme.spacing.m};
  padding-bottom: ${({ theme }) => theme.spacing.m};
  /* border: none; */
  h2 {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    /* margin-top: ${({ theme }) => theme.spacing.xs}; */
  }
  h3 {
    /* border-bottom: 2px solid ${({ theme }) => theme.colors.grey1}; */
    display: flex;
    font-weight: 600;
    color: var(--grey5);
    gap: ${({ theme }) => theme.spacing.m};
    margin-top: ${({ theme }) => theme.spacing.xs};
    /* margin-bottom: ${({ theme }) => theme.spacing.m}; */
    align-items: center;
    padding-bottom: var(--space-s);
  }
  img {
    max-width: 25%;
    max-height: 25%;
  }
  p {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    font-weight: bold;
  }
  span {
    font-weight: normal;
  }
  form {
    /* border: 2px solid red; */
  }
  input,
  label,
  textarea {
    width: 60%;
  }
  .formInputUnderline {
    border-bottom: 1px solid ${({ theme }) => theme.colors.offWhite};
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
  @media screen and (max-width: 1200px) {
    width: 95%;
    /* border: 2px solid green; */
  }
  @media screen and (max-width: 900px) {
    width: 95%;
    padding-bottom: ${({ theme }) => theme.spacing.xs};
    h1 {
      margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
    /* border: 2px solid red; */
  }
`;

export const SubmitContainer = styled.section`
  /* border: 2px solid yellow; */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block: ${({ theme }) => theme.spacing.xl};
`;
export const TopSubmit = styled.div`
  /* border: 2px solid red; */
  margin-bottom: ${({ theme }) => theme.spacing.m};
  p {
    text-align: center;
    font-size: var(--space-m);
    font-weight: bold;
  }
`;
export const BottomSubmit = styled.div`
  /* border: 2px solid blue; */
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xl};

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    width: 100%;
    button {
      width: 80%;
    }
  }
`;

export const MappedResults = styled.section`
  /* border: 1px solid orange; */
  margin-top: ${({ theme }) => theme.spacing.xl};
  h4 {
    // color: pink;
    border-bottom: 2px solid ${({ theme }) => theme.colors.orange2};
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
  td {
    text-align: center;
  }
`;

export const FileContainer = styled.section`
  display: flex;
  justify-content: space-between;
  margin-block: ${({ theme }) => theme.spacing.m};
  padding-bottom: ${({ theme }) => theme.spacing.m};
  /* border-bottom: 1px solid #e6e6e6; */
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacing.xs};
    input {
      width: 100%;
    }
  }
`;

// For Editing/Creating the Course:
export const CourseEditor = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
`;

export const CourseTabs = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-end;
  gap: var(--space-xxs);

  padding: 0 var(--space-s);

  border-bottom: 1px solid var(--grey);

  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 700px) {
    padding: 0;
  }
`;

export const CourseTab = styled.button`
  position: relative;

  flex: 0 0 auto;

  padding: var(--space-s) var(--space-l);

  border: none;
  border-radius: var(--borderRadiusSmall) var(--borderRadiusSmall) 0 0;

  background: ${({ $active }) => ($active ? 'var(--white)' : 'transparent')};

  color: ${({ $active }) => ($active ? 'var(--grey7)' : 'var(--grey4)')};

  font-family: var(--mainFont);
  font-size: 0.82rem;
  font-weight: ${({ $active }) => ($active ? 750 : 600)};

  cursor: pointer;

  transition:
    color 0.18s ease,
    background 0.18s ease;

  &::after {
    content: '';

    position: absolute;
    right: var(--space-s);
    bottom: -1px;
    left: var(--space-s);

    height: 3px;

    background: ${({ $active }) =>
      $active ? 'var(--yellow4)' : 'transparent'};

    border-radius: 999px 999px 0 0;

    transition: background 0.18s ease;
  }

  &:hover {
    color: var(--grey7);
    background: var(--yellow1);
  }

  &:focus-visible {
    outline: 3px solid var(--yellow4);
    outline-offset: -3px;
  }

  @media screen and (max-width: 700px) {
    padding: var(--space-s) var(--space-m);

    font-size: 0.76rem;
  }
`;

export const FormBackground = styled.section`
  width: 100%;

  min-height: 420px;

  /* padding: var(--space-xl); */

  margin-bottom: var(--space-l);

  background: var(--white);

  /* border: 1px solid var(--grey); */
  /* border-top: none; */
  border-radius: 0 0 var(--borderRadius) var(--borderRadius);

  box-shadow: var(--shadow-xs);

  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.xs};

    padding-bottom: var(--space-xxs);

    border-bottom: 2px solid ${({ theme }) => theme.colors.yellow4};

    font-size: var(--space-m);
    font-weight: 700;
    text-transform: capitalize;
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.s};

    color: ${({ theme }) => theme.colors.grey5};

    font-size: var(--space-m);
  }

  form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: flex-start;

    gap: ${({ theme }) => theme.spacing.xs};
  }

  .inputGroup {
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  .buttonGroup {
    width: 100%;

    display: flex;
    justify-content: flex-end;

    margin-left: ${({ theme }) => theme.spacing.s};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  @media screen and (max-width: 768px) {
    padding: var(--space-l);

    form {
      flex-direction: column;
      align-items: stretch;

      gap: ${({ theme }) => theme.spacing.s};
    }

    .inputGroup,
    .buttonGroup {
      width: 100%;
      min-width: 0;

      margin-left: 0;
    }

    select {
      min-width: 100%;
    }
  }

  @media screen and (max-width: 500px) {
    padding: var(--space-m);
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: var(--space-l);

  margin-bottom: var(--space-xl);

  h3 {
    margin: 0;

    color: var(--grey7);

    font-size: clamp(1.35rem, 2vw, 1.7rem);
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }
`;

export const SectionEyebrow = styled.p`
  margin: 0 0 var(--space-xxs) !important;

  color: var(--orange5) !important;

  font-size: 0.68rem !important;
  font-weight: 800;
  line-height: 1.3;

  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const CourseMetaGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 2fr) repeat(4, minmax(110px, 1fr));

  gap: var(--space-m);

  padding: var(--space-m);

  background: var(--cardBackground);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusSmall);

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const CourseMetaItem = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: var(--space-xxs);

  span {
    color: var(--grey3);

    font-size: 0.66rem;
    font-weight: 700;

    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  strong {
    overflow: hidden;

    color: var(--grey7);

    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.4;

    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const EditorDivider = styled.div`
  width: 100%;
  height: 1px;

  margin: var(--space-xl) 0;

  background: var(--grey);
`;

export const EditorContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: var(--space-xl);
`;

export const CopyCourseSection = styled.div`
  width: 100%;

  margin-top: var(--space-l);
  padding-top: var(--space-l);

  border-top: 1px solid var(--grey);
`;

export const CourseEditorActions = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: var(--space-m) 0 var(--space-xl);

  @media screen and (max-width: 600px) {
    justify-content: stretch;

    > * {
      width: 100%;
    }
  }
`;
